export default "__VITE_ASSET__CWF6YCZE__"